import {IUpdatable, IUpdateManager} from '@gongxigames/framework/core/types';
import {injectable} from '@gongxigames/framework/core/installer';

@injectable()
export abstract class Updatable implements IUpdatable {
    protected _updateManager?: IUpdateManager;
    protected _isPlaying = false;

    constructor(start = false) {
        start && this.start();
    }

    public start(): void {
        this._isPlaying = true;
    }

    public stop(): void {
        this._isPlaying = false;
        this._updateManager && this._updateManager.remove(this);
    }

    public pause(): void {
        this._isPlaying = !this._isPlaying;
    }

    public abstract update(dt: number): void;

    public get updateManager(): IUpdateManager | undefined {
        return this._updateManager;
    }

    public set updateManager(value: IUpdateManager | undefined) {
        this._updateManager = value;
    }

    public get isPlaying(): boolean {
        return this._isPlaying;
    }
}
